var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFleet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 103,
    viewBox: "0 0 100 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.481 28.1633L63.425 0H29.6582L46.7142 28.1633H80.481Z",
    fill: "#003563"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7136 28.1633L19.5191 74.3668C4.37283 74.3668 -4.97964 57.8535 2.79985 44.8598L29.6576 0L46.7136 28.1633Z",
    fill: "url(#paint0_linear_3717_15727)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2871 74.3666L80.4816 28.1631C95.6279 28.1631 104.98 44.6764 97.2008 57.6701L70.3431 102.529L53.2871 74.3666Z",
    fill: "url(#paint1_linear_3717_15727)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4808 28.1631L53.2863 74.3666H19.5195L46.714 28.1631H80.4808Z",
    fill: "url(#paint2_linear_3717_15727)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5195 74.3672L36.5755 102.53H70.3423L53.2863 74.3672H19.5195Z",
    fill: "#003563"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3717_15727",
    x1: 83.526,
    y1: 20.2829,
    x2: 52.6556,
    y2: 94.8777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2968A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#003366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3717_15727",
    x1: 16.4428,
    y1: 82.2365,
    x2: 47.3123,
    y2: 7.64185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2968A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#003366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3717_15727",
    x1: 49.996,
    y1: 74.3666,
    x2: 49.996,
    y2: 28.1631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D52924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#E74340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F45655"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#FC6261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF6666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FA6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#EE5555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#D94040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC3333"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleet);
export default __webpack_public_path__ + "static/media/Fleet.6cebc8b67da913f11da2fd19da60efa7.svg";
export { ForwardRef as ReactComponent };